import setCounters from './setCounters';

export default {
  setCounters,
};
